import React, { useState } from 'react';
import { DirectionsPageContainer, DirectionsPageContent, DirectionsInfoTable } from './styled';
import {INFORMATION } from "../../const"
import map from "../../images/directions.png"

function Directions() {
    return (
        <DirectionsPageContent>
            <img src={map} alt="" />

            <DirectionsInfoTable>
                <table>
                    <tbody>
                        <tr>
                            <td>주소</td>
                            <td>{INFORMATION.address}</td>
                        </tr>
                        <tr>
                            <td>전화번호</td>
                            <td>{INFORMATION.phone_number}</td>
                        </tr>
                        <tr>
                            <td>팩스</td>
                            <td>{INFORMATION.fax}</td>
                        </tr>
                    </tbody>
                </table>
            </DirectionsInfoTable>
        </DirectionsPageContent>
    );
}

function DirectionsPage() {
    return (
        <DirectionsPageContainer>
            
            <h1 className="header">찾아오시는 길</h1>


            <div style={{ margin: "30px" }}>
                { Directions() }
            </div>

        </DirectionsPageContainer>
    );
}

export default DirectionsPage;